import { useEffect } from 'react';
import { useDateDispatch, useDateSelector } from '../context/dateContext';
import { getEndDate, getIsDoneBtnClicked, getStartDate } from '../selectors/dateSelectors';
import { getEndTime, getStartTime } from '../selectors/timeSelectors';
import { setIsDoneBtnClicked } from '../ducks/dateDuck';
import { useTimeSelector } from '../context/timeContext';

const useResetIsDoneBtnClickedHook = () => {
  const dateDispatch = useDateDispatch();
  const startDate = useDateSelector(getStartDate);
  const endDate = useDateSelector(getEndDate);
  const startTime = useTimeSelector(getStartTime);
  const endTime = useTimeSelector(getEndTime);
  const isDoneBtnClicked = useDateSelector(getIsDoneBtnClicked);

  useEffect(() => {
    if (isDoneBtnClicked) {
      dateDispatch(setIsDoneBtnClicked(false));
    }
  }, [startDate, endDate, startTime, endTime]);
};

export default useResetIsDoneBtnClickedHook;
